<script>
    import R, {LOADER} from "../../lib/requests";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {newRouteLocation} from "../../lib/lib";
    import ControlLoader from "../ControlLoader.svelte";

    export let location = null;
    export let excludeLocation = null;
    export let defaultLocations = [];
    export let placeholder = '';
    export let disabled = false;

    let locationId = null;
    let name = '';
    let oldName = '';
    let timer;
    let results = [];
    let listIndex = -1;
    let showDropdown = false;
    let ignoreChanges = false;
    let loading = false;

    const search = () => {
        const onSuccess = result => {
            // results = result.filter(x => x.id != excludeId);
            results = result;
            loading = false;
            openDropdown();
        }

        const onFailure = err => {
            loading = false;
        };

        loading = true;
        R.handle(R.location.index, {name, level: 1}, onSuccess, onFailure);
    }

    const onFocus = () => {
        if (!location && !name) {
            openDefault();
        }
    }

    const onFocusOut = () => {
        if (location) {
            name = location.name;
            oldName = location.name;
        } else {
            createFromName();
        }
    }

    const onKeyDown = (event) => {
        if (results && results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter') {
                event.preventDefault();
                if (timer) {
                    clearInterval(timer);
                }
                if (listIndex > -1) {
                    onSelect(results[listIndex]);
                } else {
                    closeDropdown();
                    createFromName();
                }
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        }
    }

    const onKeyUp = (event) => {
        if (name != event.target.value) {
            name = event.target.value;
            oldName = name;
            if (timer) {
                clearInterval(timer);
            }

            if (name.length) {
                timer = setInterval(() => {
                    clearInterval(timer);
                    search();
                }, 500);
            } else {
                clear();
                openDefault();
            }
        }
    }

    const clear = () => {
        location = null;
        locationId = null;
        oldName = name;
    }

    const onSelect = (item) => {
        location = item;
        name = location.name;
        oldName = name;
        closeDropdown();
    }

    const openDefault = () => {
        let excludeId = excludeLocation ? excludeLocation.id : 0;
        results = defaultLocations.filter(x => x.id != excludeId);
        if (results.length) {
            showDropdown = true;
        }
    }

    const openDropdown = () => {
        showDropdown = true;
    }

    const closeDropdown = () => {
        showDropdown = false;
    }

    const createFromName = () => {
        if (name != '') {
            location = newRouteLocation();
            location.name = name;
        }
    }

    $: {
        // if (location && locationId != location) {
        if (location) {
            if (locationId != location.id) {
                locationId = location.id;
                name = location.name;
                oldName = name;
            }
        } else {
            if (locationId != null && !location) {
                locationId = null;
                name = '';
                oldName = '';
            }
        }
    }
</script>

<div class="dropdown-container" use:clickOutside on:click_outside="{ closeDropdown }">
    <div class="transfer-location">
        <input type="text" class="form-control" value="{ name }" on:keydown="{ onKeyDown }" on:keyup="{ onKeyUp }"
               on:focus="{ onFocus }" on:focusout="{ onFocusOut }"
               {placeholder} {disabled}>
        {#if location && !showDropdown && location.parent_name}
            <div class="info">
                { location.parent_name }
            </div>
        {/if}
        <ControlLoader {loading}/>
    </div>
    {#if showDropdown}
        {#if results.length}
            <ul class="dropdown dropdown-height">
                {#each results as item, index}
                    <li class="dropdown-item location-item pointer" class:selected="{ listIndex === index }"
                        on:click="{ () => onSelect(item) }">
                        { item.name }
                        <div class="region">
                            { item.parent_name }
                        </div>
                    </li>
                {/each}
            </ul>
        {/if}
    {/if}
</div>
{#if location && location.type_id == 0}
    <div class="mt-1">
        <input type="text" class="form-control" placeholder="address" bind:value="{ location.address }">
    </div>
{/if}

<style>
    .transfer-location {
        position: relative;
    }

    .transfer-location .info {
        position: absolute;
        left: 11px;
        top: -6px;
        height: max-content;
        font-size: 10px;
        line-height: 1;
        color: #999;
        background: #fff;
        border-radius: 2px;
        padding: 1px 2px;
    }

    .location-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .location-item .region {
        color: #666;
    }
</style>